export const routerInfo = {
  56: {
    PancakeSwap: {
      router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
      factory: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
      weth: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    },
  },
  97: {
    PancakeSwap: {
      router: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      factory: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
      weth: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
    },
    "PancakeSwap V2": {
      router: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      factory: "0x28eb363620d7a99feb17f7faef59651037a4edab",
      weth: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
    },
  },
  1: {
    UniSwap: {
      router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
      factory: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      weth: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    },
    SushiSwap: {
      router: "0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F",
      factory: "0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac",
      weth: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    },
  },
  137: {
    UniSwap: {
      router: "0xedf6066a2b290C185783862C7F4776A2C8077AD1",
      factory: "0x9e5A52f57b3038F1B8EeE45F28b3C1967e22799C",
      weth: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    },
    QuickSwap: {
      router: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
      factory: "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32",
      weth: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    },
  },
  43114: {
    UniSwap: {
      router: "0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24",
      factory: "0x9e5A52f57b3038F1B8EeE45F28b3C1967e22799C",
      weth: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    },
    Traderjoexyz: {
      router: "0x60aE616a2155Ee3d9A68541Ba4544862310933d4",
      factory: "0x9Ad6C38BE94206cA50bb0d90783181662f0Cfa10",
      weth: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    },
  },
  42161: {
    UniSwap: {
      router: "0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24",
      factory: "0xf1D7CC64Fb4452F05c498126312eBE29f30Fbcf9",
      weth: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    },
    SushiSwap: {
      router: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
      factory: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
      weth: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    },
  },
  10: {
    UniSwap: {
      router: "0x4A7b5Da61326A6379179b40d00F57E5bbDC962c2",
      factory: "0x0c3c1c532F1e39EdF36BE9Fe0bE1410313E074Bf",
      weth: "0x4200000000000000000000000000000000000006",
    },
    SushiSwap: {
      router: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      factory: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      weth: "0x4200000000000000000000000000000000000006",
    },
  },
  8453: {
    UniSwap: {
      router: "0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24",
      factory: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6",
      weth: "0x4200000000000000000000000000000000000006",
    },
    QuickSwap: {
      router: "0x4a012af2b05616Fb390ED32452641C3F04633bb5",
      factory: "0xEC6540261aaaE13F236A032d454dc9287E52e56A",
      weth: "0x4200000000000000000000000000000000000006",
    },
  },
  42220: {
    Ubeswap: {
      router: "0xE3D8bd6Aed4F159bc8000a9cD47CffDb95F96121",
      factory: "0x62d5b84bE28a183aBB507E125B384122D2C25fAE",
      weth: "0xD221812de1BD094f35587EE8E174B07B6167D9Af",
    },
    SushiSwap: {
      router: "0xB45e53277a7e0F1D35f2a77160e91e25507f1763",
      factory: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
      weth: "0x471EcE3750Da237f93B8E339c536989b8978a438",
    },
  },
  250: {
    UniSwap: {
      router: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      factory: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      weth: "https://etherscan.io",
    },
    QuickSwap: {
      router: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      factory: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      weth: "https://etherscan.io",
    },
  },
  11155111: {
    UniSwap: {
      router: "0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3",
      factory: "0xF62c03E08ada871A0bEb309762E260a7a6a880E6",
      weth: "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
    },
    QuickSwap: {
      router: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      factory: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      weth: "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
    },
  },
  80002: {
    UniSwap: {
      router: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      factory: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      weth: "https://etherscan.io",
    },
    QuickSwap: {
      router: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
      factory: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      weth: "https://etherscan.io",
    },
  },
};
